export default __webpack_public_path__ + "static/media/iot.4e0a72c2.png";